import { GpxPoint } from '../types';

const KNOWN_TRKPT_CHILDREN = new Set([
    'time',
    'ele',
    'src',
    'hdop',
    'vdop',
    'extensions'
]);

const KNOWN_EXTENSIONS = new Set([
    'speed',
    'heading',
    'speedAccuracy',
    'headingAccuracy'
]);

const parseFloatOrNull = (s: string | null): number | null => {
    if (s === null || s.trim() === '') return null;
    const n = parseFloat(s);
    return Number.isNaN(n) ? null : n;
};

const textOrNull = (parent: Element, tag: string): string | null => {
    const el = parent.getElementsByTagName(tag)[0];
    return el ? (el.textContent?.trim() ?? null) : null;
};

export function parseGpxPoints(xmlText: string): GpxPoint[] {
    const dom = new DOMParser().parseFromString(xmlText, 'application/xml');
    const errEl = dom.querySelector('parsererror');
    if (errEl) {
        throw new Error('GPX XML parse error');
    }

    const trkpts = dom.getElementsByTagName('trkpt');
    const points: GpxPoint[] = [];

    for (let i = 0; i < trkpts.length; i++) {
        const n = trkpts[i];
        const ext = n.getElementsByTagName('extensions')[0];

        const extra: Record<string, string> = {};

        for (const child of Array.from(n.children)) {
            if (!KNOWN_TRKPT_CHILDREN.has(child.tagName)) {
                extra[child.tagName] = child.textContent?.trim() ?? '';
            }
        }
        if (ext) {
            for (const child of Array.from(ext.children)) {
                if (!KNOWN_EXTENSIONS.has(child.tagName)) {
                    extra[child.tagName] = child.textContent?.trim() ?? '';
                }
            }
        }

        const time = textOrNull(n, 'time');

        points.push({
            idx: i,
            lat: parseFloat(n.getAttribute('lat') ?? 'NaN'),
            lon: parseFloat(n.getAttribute('lon') ?? 'NaN'),
            ele: parseFloatOrNull(textOrNull(n, 'ele')),
            time,
            t: time ? Date.parse(time) : null,
            src: textOrNull(n, 'src'),
            hdop: parseFloatOrNull(textOrNull(n, 'hdop')),
            vdop: parseFloatOrNull(textOrNull(n, 'vdop')),
            speed: ext ? parseFloatOrNull(textOrNull(ext, 'speed')) : null,
            heading: ext ? parseFloatOrNull(textOrNull(ext, 'heading')) : null,
            speedAccuracy: ext
                ? parseFloatOrNull(textOrNull(ext, 'speedAccuracy'))
                : null,
            headingAccuracy: ext
                ? parseFloatOrNull(textOrNull(ext, 'headingAccuracy'))
                : null,
            extra,
            dt: null,
            segDist: 0,
            cumDist: 0,
            computedSpeed: null,
            acceleration: null,
            headingDelta: null,
            yawRate: null
        });
    }

    return points;
}
